import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const fallbackCards = {
  latestNews: {
    heading: "Latest<br />News",
    title: "Go!Foton Presents Optical Excellence for Smarter AI Infrastructure at OFC 2026",
    description: "Go!Foton Presents Optical Excellence for Smarter AI Infrastructure at OFC 2026",
    image: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/productImages%2FPEACOC%20APP%20Panel_%20Isoetric%20View.png?alt=media&token=bac369ea-5caf-4abb-8f99-66c156882543",
    link: "/knowledge-center",
  },
  featuredContent: {
    heading: "Featured<br />Content",
    title: "Marking a decade of PEACOC® innovation, discover the technology’s origin and evolution",
    description: "Marking a decade of PEACOC® innovation, discover the technology’s origin and evolution",
    image: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2Fcropped-Screenshot-2025-06-25-at-08.10.34.png?alt=media&token=8230b1b5-c356-4659-9c20-09a60e822760",
    link: "/knowledge-center",
  },
  featuredTechnology: {
    heading: "Featured<br />Technology",
    title: "PEACOC 360 spooling patch panel features 100’ 24-fiber 3-millimeter of integrated cordage",
    description: "PEACOC 360 spooling patch panel features 100’ 24-fiber 3-millimeter of integrated cordage",
    image: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2Fcropped-Screenshot-2025-03-11-at-09.06.58.png?alt=media&token=7360e120-c77b-4a06-8320-8f7c5c197376",
    link: "/peacoc-360-spooling-patch-panel",
  },
};

function FeaturedCardsSection({
  variant = "home",
  isMobile = false,
  showSeparateHeadings = false,
}) {
  const [cards, setCards] = useState(fallbackCards);

  useEffect(() => {
    const loadCards = async () => {
      try {
        const snap = await getDoc(doc(db, "siteCustomization", "featuredCards"));

        if (snap.exists()) {
          setCards((prev) => ({
            ...prev,
            ...snap.data(),
          }));
        }
      } catch (err) {
        console.error("Error loading featured cards:", err);
      }
    };

    loadCards();
  }, []);

  const orderedCards = [
    {
      key: "latestNews",
      heading: "Latest<br />News",
      ...cards.latestNews,
    },
    {
      key: "featuredContent",
      heading: "Featured<br />Content",
      ...cards.featuredContent,
    },
    {
      key: "featuredTechnology",
      heading: "Featured<br />Technology",
      ...cards.featuredTechnology,
    },
  ];

  const visibleCards = isMobile ? orderedCards.slice(0, 1) : orderedCards;

  return (
    <div
      className={
        variant === "news"
          ? "solutions-section-imageBackground-news"
          : "solutions-section-imageBackground-home"
      }
      style={{ marginTop: variant === "news" ? -25 : undefined, position: "relative" }}
    >
      {variant === "home" && <div className="curved-divider-top" />}

      <div className="featured-section">
        {showSeparateHeadings && (
          <div className="featured-headings">
            <div className="featured-heading" style={{ color: "black" }}>
              <h2>Latest<br />News</h2>
            </div>

            {!isMobile && (
              <div className="featured-heading" style={{ color: "black" }}>
                <h2>Featured<br />Content</h2>
              </div>
            )}

            {!isMobile && (
              <div className="featured-heading" style={{ color: "black" }}>
                <h2>Featured<br />Technology</h2>
              </div>
            )}
          </div>
        )}

        <div className="card-row">
          {visibleCards.map((card) => (
            <div className="featured-card" key={card.key}>
              {!showSeparateHeadings && (
                <div className="card-heading">
                  <h2 dangerouslySetInnerHTML={{ __html: card.heading }} />
                </div>
              )}

              {card.image && (
                <div className="card-image-container">
                  <img
                    src={card.image}
                    alt={card.title || card.heading}
                    className="card-img"
                  />
                </div>
              )}

              <p className="card-text">
                {card.description || card.title}
              </p>

              {card.link && (
                <a
                  href={card.link}
                  className="cta-button"
                  data-analytics={
                    card.key === "featuredContent"
                      ? "home_featured_content_button"
                      : card.key === "featuredTechnology"
                        ? "home_featured_technology_button"
                        : "home_latest_news_button"
                  }
                >
                  VIEW
                </a>
              )}
            </div>
          ))}
        </div>
      </div>

      {variant === "home" && <div className="curved-divider-bottom" />}
    </div>
  );
}

export default FeaturedCardsSection;